definitionOperation